import { render, staticRenderFns } from "./CustomSubTable.vue?vue&type=template&id=047998da&"
import script from "./CustomSubTable.vue?vue&type=script&lang=js&"
export * from "./CustomSubTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports